import React from "react";
import { Box, IconButton } from "@mui/material";
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  FirstPage as FirstPageIcon,
  LastPage as LastPageIcon,
} from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";
import { useTheme } from "@mui/material/styles";

const TablePaginationActions = ({ count, page, rowsPerPage, onPageChange }) => {
  const theme = useTheme();

  const handleFirstPageButtonClick = (event) => {
    if (page > 0) onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    if (page > 0) onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    if (page < Math.ceil(count / rowsPerPage) - 1)
      onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    const lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
    if (page < lastPage) onPageChange(event, lastPage);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <Tooltip title="First Page" arrow>
        {page === 0 ? (
          <span>
            <IconButton
              onClick={handleFirstPageButtonClick}
              disabled
              aria-label="first page"
            >
              {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
          </span>
        ) : (
          <IconButton
            onClick={handleFirstPageButtonClick}
            aria-label="first page"
          >
            {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
          </IconButton>
        )}
      </Tooltip>
      <Tooltip title="Previous Page" arrow>
        {page === 0 ? (
          <span>
            <IconButton
              onClick={handleBackButtonClick}
              disabled
              aria-label="previous page"
            >
              {theme.direction === "rtl" ? (
                <KeyboardArrowRight />
              ) : (
                <KeyboardArrowLeft />
              )}
            </IconButton>
          </span>
        ) : (
          <IconButton
            onClick={handleBackButtonClick}
            aria-label="previous page"
          >
            {theme.direction === "rtl" ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
          </IconButton>
        )}
      </Tooltip>
      <Tooltip title="Next Page" arrow>
        {page >= Math.ceil(count / rowsPerPage) - 1 ? (
          <span>
            <IconButton
              onClick={handleNextButtonClick}
              disabled
              aria-label="next page"
            >
              {theme.direction === "rtl" ? (
                <KeyboardArrowLeft />
              ) : (
                <KeyboardArrowRight />
              )}
            </IconButton>
          </span>
        ) : (
          <IconButton onClick={handleNextButtonClick} aria-label="next page">
            {theme.direction === "rtl" ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </IconButton>
        )}
      </Tooltip>
      <Tooltip title="Last Page" arrow>
        {page >= Math.ceil(count / rowsPerPage) - 1 ? (
          <span>
            <IconButton
              onClick={handleLastPageButtonClick}
              disabled
              aria-label="last page"
            >
              {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
          </span>
        ) : (
          <IconButton
            onClick={handleLastPageButtonClick}
            aria-label="last page"
          >
            {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
          </IconButton>
        )}
      </Tooltip>
    </Box>
  );
};

export default TablePaginationActions;
